import type { FieldType, OperatorMeta } from './types'

const STRING_OPS: OperatorMeta[] = [
  { id: '==', label: 'Jest równe' },
  { id: '!=', label: 'Jest różne' },
  { id: 'in', label: 'Jest jednym z', multi: true },
  { id: '!in', label: 'Nie jest żadnym z', multi: true },
  { id: '*=', label: 'Zaczyna się od' },
  { id: '=*', label: 'Kończy się na' },
  { id: 'empty',  label: 'Jest puste',     novalue: true },
  { id: '!empty', label: 'Nie jest puste', novalue: true },
]

const NUMBER_OPS: OperatorMeta[] = [
  { id: '==', label: 'Ma wartość' },
  { id: '!=', label: 'Wartość różna od' },
  { id: '<',  label: 'Mniejsze niż' },
  { id: '>',  label: 'Większe niż' },
  { id: '<=', label: 'Mniejsze równe' },
  { id: '>=', label: 'Większe równe' },
  { id: 'empty',  label: 'Jest puste',     novalue: true },
  { id: '!empty', label: 'Nie jest puste', novalue: true },
]

const DATE_OPS: OperatorMeta[] = [
  { id: 'today',     label: 'Dzisiaj',    novalue: true },
  { id: 'yesterday', label: 'Wczoraj',    novalue: true },
  { id: 'until_now', label: 'Do dzisiaj', novalue: true },
  { id: 'from_now',  label: 'Od dzisiaj', novalue: true },
  { id: '==', label: 'W dniu' },
  { id: '!=', label: 'Poza dniem' },
  { id: '<',  label: 'Przed' },
  { id: '>',  label: 'Po' },
  { id: '<=', label: 'Do dnia' },
  { id: '>=', label: 'Od dnia' },
  { id: 'empty',  label: 'Jest puste',     novalue: true },
  { id: '!empty', label: 'Nie jest puste', novalue: true },
]

const BOOLEAN_OPS: OperatorMeta[] = [
  { id: 'yes', label: 'Tak', novalue: true },
  { id: 'no',  label: 'Nie', novalue: true },
]

const SELECT_OPS: OperatorMeta[] = [
  { id: '==', label: 'Jest równe' },
  { id: '!=', label: 'Jest różne' },
  { id: 'in', label: 'Jest jednym z', multi: true },
  { id: '!in', label: 'Nie jest żadnym z', multi: true },
  { id: 'empty',  label: 'Jest puste',     novalue: true },
  { id: '!empty', label: 'Nie jest puste', novalue: true },
]

export function operatorsFor(type: FieldType): OperatorMeta[] {
  switch (type) {
    case 'string':      return STRING_OPS
    case 'number':      return NUMBER_OPS
    case 'date':        return DATE_OPS
    case 'boolean':     return BOOLEAN_OPS
    case 'select':
    case 'multiselect':
    case 'team_ref':
    case 'user_ref':    return SELECT_OPS
  }
}

export function findOp(type: FieldType, opId: string): OperatorMeta | undefined {
  return operatorsFor(type).find(o => o.id === opId)
}
